import React from 'react';
import { LayoutGrid } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';
import { iconFor } from './simUtils';

const Tile = ({ active, onClick, Icon, label, count, cls, testId }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`shrink-0 flex items-center justify-between gap-4 min-w-[150px] sm:min-w-[160px] px-4 py-3.5 rounded-2xl border text-start transition-[transform,box-shadow,background-color] duration-200 hover:-translate-y-0.5 ${active ? 'bg-blue-600 border-blue-600 text-white shadow-lg shadow-blue-600/25' : 'bg-white border-slate-200 text-slate-800 hover:shadow-md'}`}>
    <div>
      <div className="font-bold text-sm sm:text-[15px]">{label}</div>
      <div className={`text-xs mt-0.5 ${active ? 'text-blue-100' : 'text-slate-400'}`}>({count})</div>
    </div>
    <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${active ? 'bg-white/15 text-white' : cls}`}><Icon className="w-5 h-5" /></div>
  </button>
);

export const SimCategoryTiles = ({ categories, sims, active, onChange }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  return (
    <div data-testid="sims-cat-tiles" className="flex gap-3 overflow-x-auto pb-2 mb-8 scrollbar-thin">
      <Tile active={active === 'all'} onClick={() => onChange('all')} testId="sims-cat-all" Icon={LayoutGrid}
        label={L('الكل', 'All')} count={sims.length} cls="bg-blue-50 text-blue-600" />
      {categories.map(c => {
        const ic = iconFor(c.icon);
        return (
          <Tile key={c.id} active={active === c.id} onClick={() => onChange(c.id)} testId={`sims-cat-${c.id}`} Icon={ic.Icon} cls={ic.cls}
            label={lang === 'ar' ? c.nameAr : (c.nameEn || c.nameAr)} count={sims.filter(s => s.categories[0] === c.id).length} />
        );
      })}
    </div>
  );
};
